// نسخه برنامه --------------------------------------------------------------
import versionInfo from "./version.json";
export const appName = versionInfo.name || "Mita Web Application";
export const appVersion = versionInfo.version || "";
export const appReleaseDate = versionInfo.releaseDate || "";

// متنی که در پایین سایدبار نمایش داده می‌شود، مثل: Mita Web Application v-1.1.9
export const appVersionLabel = `${appName} v-${appVersion}`;

export default versionInfo;
